<div class="pagination-toolbar">
  <mat-form-field appearance="fill">
    <mat-label>Rows per page</mat-label>
    <mat-select [value]="currentPageSize" (selectionChange)="onPageSizeChange($event.value)">
      <mat-option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</mat-option>
    </mat-select>
  </mat-form-field>

  <div class="page-skip">
    <mat-form-field appearance="fill">
      <mat-label>Go to page</mat-label>
      <input matInput type="number" [(ngModel)]="targetPage" [min]="1" [max]="totalPages">
    </mat-form-field>
    <button mat-raised-button color="primary" (click)="onGoToPage()">Go</button>
  </div>
  <button mat-raised-button color="accent" (click)="onExportClick()" title="Export avail lines currently displayed in Studio Pulse UI">
    Export UI
  </button>
  
  <button *ngIf="showGenerateAvails" mat-raised-button color="primary" (click)="onGenerateAvailsClick()" title="Export full list of avails sent to Studio partner">
    Export Transmitted Avails
  </button>
  
  <span class="page-info">Page {{ currentPage }} of {{ totalPages }} pages</span>
</div>